import React from 'react';

const DetailsModal = ({ details }) => {
    const { name, info, detailsImg, detailsImg1, detailsImg2 } = details;
    return (
        <div>
            <input type="checkbox" id="details-modal" class="modal-toggle" />
            <div class="modal">
                <div class="modal-box w-11/12 max-w-5xl">
                    <label for="details-modal" class="btn btn-sm btn-circle absolute right-2 top-2">✕</label>
                    {/* <div class=" ">
                        <div className='card w-96 bg-base-100 shadow-xl'>
                            <div>    <figure><img src={detailsImg} alt="items1" /></figure></div>
                            <div>   <figure><img src={detailsImg1} alt="items2" /></figure></div>
                            <div>   <figure><img src={detailsImg2} alt="items3" /></figure></div>
                        </div>
                    </div> */}

                    <div class="p-10 grid grid-cols-1 sm:grid-cols-1 md:grid-cols-3 lg:grid-cols-3 xl:grid-cols-3 gap-5">
                        <div class="rounded overflow-hidden shadow-lg">
                            <img className='w-full' src={detailsImg} alt="item1" />
                        </div>
                        <div class="rounded overflow-hidden shadow-lg">
                            <img className='w-full' src={detailsImg1} alt="item2" />
                        </div>
                        <div class="rounded overflow-hidden shadow-lg">
                            <img className='w-full' src={detailsImg2} alt="item3" />
                        </div>



                    </div>


                    <h3 class="font-bold  text-base-content">Project name: {name}</h3>
                    <p class="py-4  text-base-content">Details: {info}</p>
                    <div class="modal-action">
                        {/* <label for="details-modal" class="btn">Yay!</label> */}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DetailsModal;